import {Heading, Pane} from "evergreen-ui";
import React from "react";

export default function OperationsDefaultPage() {
    return (
        <Pane
            display="flex"
            flex={1}
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            marginLeft='auto'
            marginRight='auto'
            width='90vw'
            height='70vh'
            textAlign='center'
        >
            <Heading size={700} marginTop={-100} marginBottom={16}>Для продолжения работы выберите слева тип расчетов</Heading>
        </Pane>
    )
}